/** @jsx jsx */
import { jsx } from '@emotion/core'
import { Badge, Tabs } from 'antd-mobile'
import { GAME_TYPE } from '@game-type/game-market-types'
import useRootStore from '@store/useRootStore'
import { Models } from 'rmc-tabs/lib/Models'
import * as _ from 'lodash'
import * as Utils from '@utils/utils'
import { Fragment } from 'react'
import { BadgeStyle } from '@styles/base.style'
import { useOnMount, useOnUnmount } from '@utils/reactExt'
import { observer } from 'mobx-react'
import { ProducerType } from '@game-type/betradar-type'

export const GAME_TAB_LIST = [
  {
    title: <span className="txt">스포츠</span>,
    name: '스포츠',
    key: GAME_TYPE.CROSS,
  },
  {
    title: <span className="live-txt txt">라이브</span>,
    name: '라이브',
    key: GAME_TYPE.LIVE,
  },
]

function getGameKey(category) {
  return GAME_TAB_LIST[category].key
}

function GameTab() {
  const { matchupStore, routerStore, oddsStore, authStore, userStore, componentStore, logStore } = useRootStore()
  const { categoryTab, club = {}, currentGameKey } = matchupStore
  const { notificationData } = userStore
  const { id: clubId } = club

  const liveTab = _.find(GAME_TAB_LIST, { key: GAME_TYPE.LIVE })
  if (liveTab) {
    if (matchupStore.isAvailableLiveMatch(clubId, currentGameKey)) {
      const liveTitle = (
        <Fragment>
          <span className="live-txt txt">라이브</span>
          <Badge
            text={notificationData ? notificationData.liveMatchCount : 0}
            overflowCount={99}
            css={BadgeStyle}
            className="left-tab-badge live-badge"
          />
        </Fragment>
      )
      liveTab.title = liveTitle
    } else {
      liveTab.title = <span className="live-txt txt">라이브</span>
    }
  }

  useOnMount(() => {
    matchupStore.setCategoryTab(0, GAME_TYPE.CROSS, true)
  })

  useOnUnmount(() => {
    matchupStore.setCategoryTab(0, GAME_TYPE.CROSS, true)
  })
  const onTabGameChanged = async (td: Models.TabData, idx: number): Promise<void> => {
    if (td.key === GAME_TYPE.LIVE) {
      logStore.writeButtonLog({ pageId: 'b020', buttonId: '001' }).catch(console.error)
    }
    // matchupStore.cleanup()
    const gameKey = getGameKey(idx)
    const pathName = routerStore.location.pathname
    if (pathName) {
      const [, pageName, tabName, clubId] = pathName.split('/')
      const gameTypeKey = _.find(GAME_TAB_LIST, { key: tabName as GAME_TYPE })
      if (gameTypeKey) {
        const hashParameters = Utils.getAllHashParameters(true)
        routerStore.push(`/${pageName}/${gameKey}/${clubId}${hashParameters}`)
      }
    }

    matchupStore.setCategoryTab(idx, gameKey, true)
    if (gameKey !== GAME_TYPE.LIVE) {
      oddsStore.cleanup()
    }

    authStore.checkAdultAuthentication().catch(console.error)
    componentStore.updateIsVisibleEtcAlertOptions()
    componentStore.setIsGoToFirstScrollOfSportTab(true)

    if (gameKey === GAME_TYPE.LIVE) {
      if(_.find(matchupStore.cart, item => item.producerId === ProducerType.LIVEODDS)) {
      matchupStore.testChangeRate(matchupStore.cart, true).catch(console.error)
      }
    }
  }

  return (
    <Tabs
      tabs={GAME_TAB_LIST}
      initialPage={categoryTab}
      page={categoryTab}
      onChange={onTabGameChanged}
      prefixCls={'match-tab am-tabs'}
    />
  )
}

export default observer(GameTab)
